import { call, put, select } from 'redux-saga/effects';
import { LoadType } from 'store/sagas/apiService/types';
import { queryData } from 'store/sagas/apiService';
import { Route, State as RouteState } from 'config/routes';
import { navigateTo } from 'store/state/router/actions';
import { localDataDocSelector } from 'store/state/domainData/selectors/localData';

function generateCityDocId(city: string) {
  const docParts = [ city, 'ישראל' ];
  return docParts.join('-').split(' ').join('-').replace(/[-]+/g, '-');
}

/**
 * The Education City page should not be accessible directly as it is a legacy page,
 * so for SEO reasons we redirect to the local page if the city is valid and document exists,
 * otherwise we redirect to the home page.
 */
export function* educationCityPageHandler(params: RouteState) {
  try {
    const city = params.params.city;
    const cityDocId = generateCityDocId(city);

    yield call(queryData, {
      loadType: LoadType.LocalData,
      meta: { variables: { docId: cityDocId } },
    });

    const localData: ReturnType<typeof localDataDocSelector> = yield select(localDataDocSelector);

    if (localData && localData.name === city) {
      yield put(navigateTo(Route.LocalPage, { id: cityDocId }, { replace: true, ssrHttpStatus: 301 }));
    }
    else {
      yield put(navigateTo(Route.Home, {}, { replace: true, ssrHttpStatus: 301 }));
    }
  }
  catch (error) {
    yield put(navigateTo(Route.Home, {}, { replace: true }));
  }
}
